/* store.js */
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import apis from './axiosApis/apis'
import params from './params'
import createPersistedState from 'vuex-persistedstate'
import utils from './assets/js/utils'
import SecureLS from 'secure-ls'
let ls = new SecureLS({ isCompression: false })

Vue.use(Vuex)

const defaultParamModule = {
  state: {
    version: '0.5',
    fullWidth: 0,
    fullHeight: 0,
    toRoute: '',
    lastSignUpUserEmail: '',
    regionList: null,
    districtAllList: null
  },
  mutations: {
    setFullWidthHeight (state, payload) {
      state.fullWidth = payload.width
      state.fullHeight = payload.height
    },
    setToRoute (state, payload) {
      state.toRoute = payload.toRoute
    },
    setLastSignUpUserEmail (state, payload) {
      state.lastSignUpUserEmail = payload.lastSignUpUserEmail
    },
    setRegionList (state, payload) {
      state.regionList = payload.regionList
    },
    setDistrictAllList (state, payload) {
      state.districtAllList = payload.districtAllList
    }
  },
  getters: {
    getToRoute: (state) => {
      return state.toRoute
    },
    getVersion: (state) => {
      return state.version
    },
    getLastSignUpUserEmail: (state) => {
      return state.lastSignUpUserEmail
    },
    getRegionList: (state) => {
      return state.regionList
    },
    getDistrictAllList: (state) => {
      return state.districtAllList
    }
  }
}

const signUpModule = {
  state: {
    signUpCertFileInfo: {
      fileName: null,
      fileInfo: null
    },
    signUpCertFileInfoFlag: false
  },
  mutations: {
    setSignUpCertFileInfo (state, payload) {
      state.signUpCertFileInfo.fileName = payload.fileName
      state.signUpCertFileInfo.fileInfo = payload.fileInfo
    },
    setSignUpCertFileInfoFlag (state) {
      state.signUpCertFileInfoFlag = !state.signUpCertFileInfoFlag
    }
  },
  getters: {
    getSignUpCertFileInfo: (state) => {
      return state.signUpCertFileInfo
    },
    getSignUpCertFileInfoFlag: (state) => {
      return state.signUpCertFileInfoFlag
    }
  }
}

const enrollModule = {
  state: {
    enrollState: null,
    adUiState: null,
    removeWatchTrigger: false,
    areaSelectedTrigger: false,
    temporaryAdImgExist: null
  },
  mutations: {
    setAdUiStateValue (state, payload) {
      state.adUiState[payload.type] = payload.value
    },
    setAdUiState (state, payload) {
      let isRewardTypeCoupon = null
      let category = null
      let titleText = null
      let titleImg = null
      let answerImg = [null, null, null, null]
      let answerText = [null, null, null, null]

      if(payload.type !== 'init') {
        // 초기화가 아닐 경우(임시저장에서 온 경우) 값 입력
        let categoryParams = params.category
        category = payload.data.category != null ? categoryParams.find(items => items.itemKey === payload.data.category).text : null
        isRewardTypeCoupon = payload.data.rewardType === 'COUPON'
        titleImg = payload.data.questionSource
        titleText = payload.data.questionText
        for(var i = 0; i < payload.data.adChoices.length; i++) {
          answerImg[i] = payload.data.adChoices[i].choiceImg
          answerText[i] = payload.data.adChoices[i].choiceText
        }
      }

      state.adUiState = {
        isRewardTypeCoupon: isRewardTypeCoupon,
        category: category,
        titleText: titleText,
        titleImg: titleImg,
        answer1Text: answerText[0],
        answer2Text: answerText[1],
        answer3Text: answerText[2],
        answer4Text: answerText[3],
        answer1Img: answerImg[0],
        answer2Img: answerImg[1],
        answer3Img: answerImg[2],
        answer4Img: answerImg[3]
      }
    },
    setEnrollStateValue (state, payload) {
      const findArr = state.enrollState.find(items => items.type === payload.type)
      if (payload.type === 'job' || payload.type === 'age') {
        findArr.value.push(payload.value)
      }else if(payload.type === 'area') {
        // vuejs의 반응형을 트리거 하기 위해 아래코드로 대체
        // findArr.value[payload.index] = payload.value
        findArr.value.splice(payload.index, 1, payload.value)
      }else if(payload.type === 'answerImg' || payload.type === 'answerText') {
        // vuejs의 반응형을 트리거 하기 위해 아래코드로 대체
        // findArr.value[payload.adChoiceNumber - 1] = payload.value
        findArr.value.splice(payload.adChoiceNumber - 1, 1, payload.value)
      }else if (payload.type === 'period') {
        if(payload.subType === 'start') {
          findArr.startDate = payload.startDate
        }else{
          findArr.endDate = payload.endDate
        }
        findArr.value = parseInt(parseInt(findArr.endDate.getTime() - findArr.startDate.getTime()) / (24 * 3600 * 1000)) + 1
        findArr.value = findArr.value < 0 ? 0 : findArr.value
      }else if(payload.type === 'coupon') {
        if(payload.subType === 'title') {
          findArr.value.title = payload.value
        }else{
          findArr.value.expiredDate = payload.value
        }
      }else{
        findArr.value = payload.value
      }
    },
    setEnrollStateArr (state, payload) {
      // arr초기화
      const enrollArr = state.enrollState.find(items => items.type === payload.type)
      enrollArr.value = payload.value
    },
    removeEnrollStateValue (state, payload) {
      const findArr = state.enrollState.find(items => items.type === payload.type)
      const valueArr = findArr.value
      const idx = valueArr.indexOf(payload.value)
      if (idx > -1) {
        valueArr.splice(idx, 1)
      }
    },
    setEnrollState (state, payload) {
      let tomorrowDate = new Date()
      tomorrowDate.setHours(24, 0, 0, 0) // next midnight

      let titleImg = null
      let titleText = null
      let choiceImg = [null, null, null, null]
      let choiceText = [null, null, null, null]
      let category = null
      let toward = null
      let gender = null
      let job = []
      let age = []
      let area = [null, null, null, null, null]
      let reward = null
      let startDate = tomorrowDate
      let endDate = tomorrowDate
      let periodValue = 1
      let couponTitle = null
      let couponExpiredDate = tomorrowDate
      let pollidePoint = 0
      let dailyBudget = 0
      let totalBudget = 0

      if(payload.type !== 'init') {
        // 초기화가 아닐 경우 값 입력
        titleImg = payload.data.questionSource
        titleText = payload.data.questionText
        for(var i = 0; i < payload.data.adChoices.length; i++) {
          choiceImg[i] = payload.data.adChoices[i].choiceImg
          choiceText[i] = payload.data.adChoices[i].choiceText
        }
        category = payload.data.category
        toward = payload.data.targetGroup != null ? payload.data.targetGroup : null
        gender = payload.data.targetGender != null ? payload.data.targetGender : null
        // 모두 선택 가능 배열들 format
        // job
        if(payload.data.targetJobs != null) {
          if(payload.data.targetJobs.length === 9) {
            // 모두 선택인 경우
            job = [-1]
          }else {
            job = payload.data.targetJobs
          }
        }else {
          job = []
        }
        // age
        if(payload.data.targetAgeGroups != null) {
          if(payload.data.targetAgeGroups.length === 6) {
            // 모두 선택인 경우
            age = [-1]
          }else {
            age = payload.data.targetAgeGroups
          }
        }else {
          age = []
        }
        // area
        // area = payload.data.targetAreas != null ? payload.data.targetAreas : [null, null, null, null, null]
        if(payload.data.targetAreas != null) {
          if(payload.data.targetAreas.length >= 5 &&
            payload.data.targetAreas.filter(arr => arr < 0).length === 0 &&
            payload.data.targetAreas.filter(arr => arr == null).length === 0) {
            // 전체값이 있을 가능성이 있는 경우
            area = utils.setPackedAreas(payload.data.targetAreas)
          }else {
            area = payload.data.targetAreas
          }
        }else {
          area = [null, null, null, null, null]
        }
        reward = payload.data.rewardType != null ? payload.data.rewardType : null
        startDate = new Date(moment(payload.data.startAt.split(' ')[0], 'YYYY-MM-DD').format('YYYY-MM-DD'))
        // DB에 저장된 값은 다음날 00시 이므로 -1처리를 해줘야됨
        endDate = new Date(moment(payload.data.endAt.split(' ')[0], 'YYYY-MM-DD').add(-1, 'days').format('YYYY-MM-DD'))
        periodValue = parseInt(parseInt(endDate.getTime() - startDate.getTime()) / (24 * 3600 * 1000)) + 1
        periodValue = periodValue < 0 ? 0 : periodValue
        if(payload.data.rewardCoupons[0] != null) {
          couponTitle = payload.data.rewardCoupons[0].title != null ? payload.data.rewardCoupons[0].title : null
          if(payload.data.rewardCoupons[0].expiredDate != null) {
            couponExpiredDate = new Date(parseInt(payload.data.rewardCoupons[0].expiredDate.split(' ')[0].split('-')[0]), parseInt(payload.data.rewardCoupons[0].expiredDate.split(' ')[0].split('-')[1]) - 1, parseInt(payload.data.rewardCoupons[0].expiredDate.split(' ')[0].split('-')[2]))
          }
        }
        pollidePoint = payload.data.rewardPoint
        dailyBudget = payload.data.dailyBudget
      }
      state.enrollState = [
        {
          type: 'titleImg',
          value: titleImg
        },
        {
          type: 'titleText',
          value: titleText
        },
        {
          type: 'answerImg',
          value: [
            {
              choiceImg: choiceImg[0]
            },
            {
              choiceImg: choiceImg[1]
            },
            {
              choiceImg: choiceImg[2]
            },
            {
              choiceImg: choiceImg[3]
            }
          ]
        },
        {
          type: 'answerText',
          value: [
            {
              choiceText: choiceText[0]
            },
            {
              choiceText: choiceText[1]
            },
            {
              choiceText: choiceText[2]
            },
            {
              choiceText: choiceText[3]
            }
          ]
        },
        {
          type: 'category',
          value: category
        },
        {
          type: 'toward',
          value: toward
        },
        {
          type: 'gender',
          value: gender
        },
        {
          type: 'job',
          value: job
        },
        {
          type: 'age',
          value: age
        },
        {
          type: 'area',
          value: area
        },
        {
          type: 'reward',
          value: reward
        },
        {
          type: 'period',
          startDate: startDate,
          endDate: endDate,
          value: periodValue
        },
        {
          type: 'coupon',
          value: {
            title: couponTitle,
            expiredDate: couponExpiredDate
          }
        },
        {
          type: 'pollidePoint',
          value: pollidePoint
        },
        {
          type: 'dailyBudget',
          value: dailyBudget
        },
        {
          type: 'totalBudget',
          value: totalBudget
        }
      ]
    },
    setRemoveWatchTrigger (state) {
      state.removeWatchTrigger = !state.removeWatchTrigger
    },
    setAreaSelectedTrigger (state) {
      state.areaSelectedTrigger = !state.areaSelectedTrigger
    },
    setTemporaryAdImgExist (state, payload) {
      let isTitleImgExist = false
      let isAnswerImgExist = [
        false,
        false,
        false,
        false
      ]

      // 임시저장된 광고가 이미지를 가지고 있으면 true, 아니면 false
      if(payload.type === 'temporary') {
        isTitleImgExist = payload.data.questionSource != null
        for (var i = 0; i < payload.data.adChoices.length; i++) {
          isAnswerImgExist[i] = payload.data.adChoices[i].choiceImg != null
        }
      }

      state.temporaryAdImgExist = {
        titleImg: isTitleImgExist,
        answerImg: isAnswerImgExist
      }
    }
  },
  actions: {
    async regionListApi () {
      const response = await apis.getRegionList()
      return response
    },
    async districtListApiByRegionId ({ commit }, payload) {
      const response = await apis.getDistrictList(payload)
      return response
    },
    async adCreateApi ({ commit }, payload) {
      await apis.postAdCreate(payload)
    },
    async adCreateByTemporaryApi ({ commit }, payload) {
      // 임시저장된 광고를 광고올리기
      await apis.postAdTemporaryToCreate(payload.data, payload.adId, payload.beforeImgExist)
    },
    async temporaryAdCreateApi ({ commit }, payload) {
      // 임시저장하기
      await apis.postTemporaryAdCreate(payload)
    },
    async temporaryAdModifyApi ({ commit }, payload) {
      // 임시저장된 광고 임시저장하기
      await apis.postTemporaryAdTemporary(payload.data, payload.adId, payload.beforeImgExist)
    },
    async temporaryAdDeleteApi ({ commit }, payload) {
      // 임시저장 광고 지우기
      await apis.deleteTemporaryAd(payload)
    }
  },
  getters: {
    getAdUiState: (state) => {
      return state.adUiState
    },
    getEnrollStateValue: (state) => (type) => {
      return state.enrollState.find(items => items.type === type).value
    },
    getEnrollStateArrayValue: (state) => (type, payload) => {
      let arr = state.enrollState.find(items => items.type === type).value
      return arr[payload.index][payload.valueName]
    },
    getTemporaryAdImgExist: (state) => {
      return state.temporaryAdImgExist
    },
    getEnrollAvailable: (state) => (payload) => {
      /**
       * ERROR_CODE
       * ok: 0
       * invalidCouponText: 1
       * invalidPollidePoint: 2
       * answerCount < 2: 4
       * startDate < tomorrow: 5
       * startDate > endDate: 6
       * invalidCouponExpiredDate: 7
       * notnull(titleText): 8
       // * notnull(titleImg): 9
       * notnull(category): 10
       * notnull(toward): 11
       * notnull(gender): 12
       * notnull(job): 13
       * notnull(age): 14
       * notnull(area): 15
       * notnull(reward): 16
       * notnull(totalBudget): 17
       * notnull(answerText): 18
       * totalBudget > availableAdPoint: 19
       * dailyBudget < rewardPoint: 20
       */
      let allowDate = new Date()
      allowDate.setHours(24, 0, 0, 0) // next midnight
      if(state.enrollState.find(items => items.type === 'titleText').value == null ||
        state.enrollState.find(items => items.type === 'titleText').value === '' ||
        state.enrollState.find(items => items.type === 'titleText').value.trim() === '') {
        return 8
      }
      // if(state.enrollState.find(items => items.type === 'titleImg').value == null || state.enrollState.find(items => items.type === 'titleImg').value === '') {
      //   return 9
      // }
      if(state.enrollState.find(items => items.type === 'category').value == null) {
        return 10
      }
      if(state.enrollState.find(items => items.type === 'toward').value == null) {
        return 11
      }
      if(state.enrollState.find(items => items.type === 'gender').value == null) {
        return 12
      }
      if(state.enrollState.find(items => items.type === 'job').value.length === 0) {
        return 13
      }
      if(state.enrollState.find(items => items.type === 'age').value.length === 0) {
        return 14
      }
      let areas = state.enrollState.find(items => items.type === 'area').value
      if(areas.filter(arr => arr != null).length === 0) {
        return 15
      }else if(payload.areaCounts !== areas.filter(arr => arr != null).length) {
        return 15
      }
      if(state.enrollState.find(items => items.type === 'period').startDate < allowDate) {
        return 5
      }
      if(state.enrollState.find(items => items.type === 'period').startDate > state.enrollState.find(items => items.type === 'period').endDate) {
        return 6
      }
      if(state.enrollState.find(items => items.type === 'reward').value == null) {
        return 16
      }
      if((state.enrollState.find(items => items.type === 'reward').value === 'COUPON' || state.enrollState.find(items => items.type === 'reward').value === 'ALL') &&
        (state.enrollState.find(items => items.type === 'coupon').value.title == null || state.enrollState.find(items => items.type === 'coupon').value.title === '' || state.enrollState.find(items => items.type === 'coupon').value.title.trim() === '')) {
        return 1
      }
      if(state.enrollState.find(items => items.type === 'reward').value === 'COUPON' &&
        state.enrollState.find(items => items.type === 'coupon').value.expiredDate < allowDate) {
        return 7
      }
      if((state.enrollState.find(items => items.type === 'reward').value === 'POLLIDE_POINT' || state.enrollState.find(items => items.type === 'reward').value === 'ALL') &&
        (state.enrollState.find(items => items.type === 'pollidePoint').value === 0 || state.enrollState.find(items => items.type === 'pollidePoint').value === '')) {
        return 2
      }
      if((state.enrollState.find(items => items.type === 'reward').value === 'POLLIDE_POINT' || state.enrollState.find(items => items.type === 'reward').value === 'ALL') &&
        (state.enrollState.find(items => items.type === 'dailyBudget').value < state.enrollState.find(items => items.type === 'pollidePoint').value)) {
        return 20
      }
      let totalBudget = state.enrollState.find(items => items.type === 'totalBudget').value
      if(totalBudget === 0) {
        return 17
      } else if(totalBudget > payload.availableAdPoint) {
        return 19
      }
      let answerTextArray = state.enrollState.find(items => items.type === 'answerText').value
      let answerImgArray = state.enrollState.find(items => items.type === 'answerImg').value
      let answerTextCount = 0
      let answerImgCount = 0
      for(var i = 0; i < answerTextArray.length; i++) {
        answerTextCount += answerTextArray[i].choiceText == null || answerTextArray[i].choiceText === '' || state.enrollState.find(items => items.type === 'titleText').value.trim() === '' ? 0 : 1
      }
      // eslint-disable-next-line no-redeclare
      for(var i = 0; i < answerImgArray.length; i++) {
        answerImgCount += answerImgArray[i].choiceImg == null || answerImgArray[i].choiceImg === '' ? 0 : 1
      }
      if(answerTextCount < answerImgCount) {
        return 18
      } else if(answerTextCount < 2) {
        return 4
      }

      return 0
    },
    getEnrollState: (state) => {
      return state.enrollState
    },
    getRemoveWatchTrigger (state) {
      return state.removeWatchTrigger
    },
    getAreaSelectedTrigger (state) {
      return state.areaSelectedTrigger
    }
  }
}

const adUserModule = {
  state: {
    accessToken: '',
    refreshToken: '',
    adUserValue: {
      name: '',
      images: [],
      thumbnail: '',
      address: '',
      description: '',
      certificate: '',
      status: '',
      invoice: null,
      adPoint: 0,
      availableAdPoint: 0
    },
    myInfoState: [
      // 수정 상태 ture: 활성화, false: 비활성화
      {
        type: 'isEditable',
        value: false
      },
      // 이미지 초기화 트리거, 기본 false. 수정 취소, 확인시 트리거됨
      {
        type: 'imgReloadTrigger',
        value: false
      }
    ],
    tempImgStore: [
      null,
      null,
      null,
      null,
      null
    ],
    signUpCertFileInfo: {
      fileName: null,
      fileInfo: null
    }
  },
  mutations: {
    setAccessTokenValue (state, payload) {
      state.accessToken = payload.accessToken
    },
    setRefreshTokenValue (state, payload) {
      state.refreshToken = payload.refreshToken
    },
    setAdUserValue (state, payload) {
      state.adUserValue = payload
    },
    setAdUserValueByType (state, payload) {
      state.adUserValue[payload.type] = payload.value
    },
    setMyInfoStateValue (state, payload) {
      const findArr = state.myInfoState.find(items => items.type === payload.type)
      findArr.value = payload.value
    },
    setTempImgStore (state, payload) {
      state.tempImgStore[payload.index] = payload.value
    }
  },
  actions: {
    async signUpTokenApi () {
      const response = await apis.getSignUpToken()
      return response
    },
    async signUpApi ({ commit }, payload) {
      const response = await apis.postSignUp(payload)
      return response
    },
    async findPwdApi ({ commit }, payload) {
      const response = await apis.getFindPwd(payload)
      return response
    },
    async accessTokenApi ({ commit }, payload) {
      const response = await apis.getOauthToken(payload)
      commit('setAccessTokenValue', {accessToken: response.data.access_token})
      commit('setRefreshTokenValue', {refreshToken: response.data.refresh_token})
    },
    async adUserInfoApi ({ commit }) {
      const response = await apis.getAdUserInfo()
      commit('setAdUserValue',
        {
          name: response.data.data.name,
          images: response.data.data.images,
          thumbnail: response.data.data.thumbnails[0],
          address: response.data.data.address,
          description: response.data.data.description,
          certificate: response.data.data.certImageUrl,
          status: response.data.data.status,
          invoice: response.data.data.invoice,
          adPoint: response.data.data.adPoint,
          availableAdPoint: response.data.data.availableAdPoint
        }
      )
    },
    async checkWithdrawAdUserApi ({ commit }) {
      const response = await apis.getAdUserInfo()
      if (response.data.data.status === 'ENABLED') {
        commit('setAdUserValue',
          {
            name: response.data.data.name,
            images: response.data.data.images,
            thumbnail: response.data.data.thumbnails[0],
            address: response.data.data.address,
            description: response.data.data.description,
            certificate: response.data.data.certImageUrl,
            status: response.data.data.status,
            invoice: response.data.data.invoice,
            adPoint: response.data.data.adPoint,
            availableAdPoint: response.data.data.availableAdPoint
          }
        )
        return false
      }else {
        return true
      }
    },
    async modifyAdUserInfoApi ({ commit }, payload) {
      let response = await apis.postModifyAdUserInfo(payload)
      return response
    },
    async modifyAdUserInvoiceApi ({ commit }, payload) {
      await apis.postModifyAdUserInvoice(payload)
    },
    async deleteAdUserImagesApi ({ commit }, payload) {
      await apis.deleteAdUserImages(payload)
    },
    async saveAdUserCertImageApi ({ commit }, payload) {
      await apis.postModifyAdUserCertImage(payload)
    },
    async deleteAdUserCertImageApi () {
      await apis.deleteAdUserCertImage()
    },
    async sendVerifyEmailApi ({ commit }, payload) {
      const response = await apis.sendVerifyEmail(payload)
      return response
    },
    async verifyNumberApi ({ commit }, payload) {
      const response = await apis.postVerifyNumber(payload)
      return response
    },
    async getAdUserCouponCountsApi () {
      const response = await apis.getAdUserCouponCount()
      return response
    },
    async withdrawAdUser () {
      await apis.deleteAdUser()
    }
  },
  getters: {
    getAccessToken: (state) => {
      return state.accessToken
    },
    getRefreshToken: (state) => {
      return state.refreshToken
    },
    getAdUserStateValue: (state) => (type) => {
      return state.adUserValue[type]
    },
    getMyInfoStateValue: (state) => (type) => {
      return state.myInfoState.find(items => items.type === type).value
    },
    getTempImgStore: (state) => {
      return state.tempImgStore
    },
    getAdUserState: (state) => {
      return state.adUserValue
    }
  }
}

const adModule = {
  state: {
    adListSize: 20
  },
  actions: {
    async exposedChartDataApi () {
      const response = await apis.getExposedChartData()
      return response
    },
    async answeredChartDataApi () {
      const response = await apis.getAnsweredChartData()
      return response
    },
    async adFeeChartDataApi () {
      const response = await apis.getAdFeeChartData()
      return response
    },
    async adListApi ({ commit, state }, payload) {
      const response = await apis.getMyAdList({adPage: payload.pageIndex, adListSize: state.adListSize, searchText: payload.searchText})
      return response
    },
    async adCountsApi ({ commit, state }, payload) {
      const response = await apis.getAdCounts({searchText: payload.searchText})
      return response
    },
    async adInfoApi ({ commit }, payload) {
      const response = await apis.getAdInfo(payload)
      return response
    },
    async adStatApi ({ commit }, payload) {
      const response = await apis.getAdStats(payload)
      return response
    }
  },
  mutations: {
    setAdListSize: (state, payload) => {
      state.adListSize = payload.adListSize
    },
    setAdPage: (state, payload) => {
      state.adPage = payload.adPage
    }
  },
  getters: {
    getAdListSize: (state) => {
      return state.adListSize
    },
    getAdPage: (state) => {
      return state.adPage
    }
  }
}

const feeInfoModule = {
  state: {
    searchDate: {
      startAt: new Date().setDate(new Date().getDate() - 1),
      endAt: new Date().setDate(new Date().getDate() - 1)
    }
  },
  mutations: {
    setSearchDate: (state, payload) => {
      state.searchDate[payload.type] = payload.value
    }
  },
  actions: {
    async feeInfoListApi ({ commit, state }) {
      const response = await apis.getFeeInfoList({startAt: state.searchDate.startAt, endAt: state.searchDate.endAt})
      return response
    }
  },
  getters: {
    getSearchDate: (state) => (type) => {
      return state.searchDate[type]
    }
  }
}

const followerModule = {
  state: {
    followerInfoSize: 20,
    followerRequestSize: 20
  },
  actions: {
    async followerInfoApi ({ commit, state }, payload) {
      const response = await apis.getFollowerInfo({followerInfoPage: payload.pageIndex, followerInfoSize: state.followerInfoSize})
      return response
    },
    async followerRequestApi ({ commit, state }, payload) {
      const response = await apis.getFollowerRequest({followerRequestPage: payload.pageIndex, followerRequestSize: state.followerRequestSize})
      return response
    },
    async districtListAllApi () {
      const response = await apis.getAllDistrictList()
      return response
    },
    async followerAcceptanceApi ({ commit }, payload) {
      await apis.postFollowerAcceptApi(payload)
    },
    async followerRejectionApi ({ commit }, payload) {
      await apis.postFollowerRejectApi(payload)
    },
    async followerCancelApi ({ commit }, payload) {
      await apis.postFollowerCancelApi(payload)
    }
  }
}

const paymentModule = {
  state: {
    IMPCode: 'imp13307844',
    bizNum: '1468600182',
    paymentMethod: null,
    isPaymentReqSuccess: null,
    merchantId: null,
    vBankData: {
      vBankNum: null,
      vBankName: null,
      vBankDate: null,
      vBankAmount: null
    }
  },
  mutations: {
    setPaymentMethod (state, payload) {
      state.paymentMethod = payload.paymentMethod
    },
    setPaymentReq (state, payload) {
      state.isPaymentReqSuccess = payload.result
    },
    setMerchantId (state, payload) {
      state.merchantId = payload.merchantId
    },
    setVBankData (state, payload) {
      let vBankDate = payload.vBankDate.split(' ')[0].split('-')
      state.vBankData.vBankDate = vBankDate[0] + '년 ' + vBankDate[1] + '월 ' + vBankDate[2] + '일 까지'
      state.vBankData.vBankName = payload.vBankName
      state.vBankData.vBankNum = payload.vBankNum
      state.vBankData.vBankAmount = payload.vBankAmount.toLocaleString() + '원'
    }
  },
  getters: {
    getPaymentMethod: (state) => {
      return state.paymentMethod
    },
    getPaymentReq: (state) => {
      return state.isPaymentReqSuccess
    },
    getMerchantId: (state) => {
      return state.merchantId
    },
    getIMPCode: (state) => {
      return state.IMPCode
    },
    getBizNum: (state) => {
      return state.bizNum
    },
    getVBankData: (state) => {
      return state.vBankData
    }
  },
  actions: {
    async createMerchantDataApi ({ commit }, payload) {
      const response = await apis.postMerchantData(payload)
      return response
    },
    async completePaymentApi ({ commit }, payload) {
      const response = await apis.postCompletePayment(payload)
      return response
    }
  }
}

const store = new Vuex.Store({
  modules: {
    defaultParam: defaultParamModule,
    signUp: signUpModule,
    enroll: enrollModule,
    adUser: adUserModule,
    ad: adModule,
    feeInfo: feeInfoModule,
    follower: followerModule,
    payment: paymentModule
  },
  plugins: [
    createPersistedState({
      paths: ['adUser'],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key)
      }
    })
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/store.js